"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpBadStatusCodeError = void 0;
var genericError_1 = require("./genericError");
var HttpBadStatusCodeError = /** @class */ (function (_super) {
    __extends(HttpBadStatusCodeError, _super);
    function HttpBadStatusCodeError(params, _statusCode, _domain) {
        var _this = this;
        var message;
        var domain;
        var details;
        if (typeof params === 'string') {
            message = params;
            domain = _domain;
        }
        else {
            message = params.message;
            domain = params.domain;
            details = params.details;
        }
        _this = _super.call(this, { type: 'BadStatusCodeError', domain: domain || 'unknown-domain.by-peperrors', message: message, details: details }) || this;
        if (typeof params === 'string') {
            _this.statusCode = _statusCode;
        }
        else {
            _this.statusCode = params.statusCode;
        }
        Object.setPrototypeOf(_this, HttpBadStatusCodeError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, HttpBadStatusCodeError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return HttpBadStatusCodeError;
}(genericError_1.GenericError));
exports.HttpBadStatusCodeError = HttpBadStatusCodeError;
//# sourceMappingURL=httpBadStatusCodeError.js.map